<template>
  <div class="home">
    <h1 class="mt-16 text-h4 font-weight-bold text-center">
      {{ $city.name }}健檢預約平台
    </h1>
    <h2
      class="mt-2 mb-13 text-h5 font-weight-bold text-center"
      style="color: var(--home-title-text)"
    >
      整合在地院所及衛生所健檢服務<br />篩檢項目依現場實際查詢為主、部分院所酌收掛號費
    </h2>
    <div>
      <v-row class="justify-center mx-0">
        <v-col sm="12" md="8" class="text-center">
          <h2 class="font-weight-bold mb-8 pa-6 subtitle d-inline-flex align-center">
            健檢服務項目與資格
          </h2>
          <div class="d-flex flex-wrap justify-center mb-8">
            <div class="item mb-8" v-for="item in items">
              <div class="mb-4" style="position: relative">
                <v-img
                  contain
                  max-height="50"
                  :src="item.logo"
                  alt=""
                ></v-img>
                <div class="image-overlay"></div>
              </div>
              <h3 class="font-weight-bold text-h6 blue--text text--darken-4">
                {{ item.title }}
              </h3>
              <div class="item-content" v-html="item.content"></div>
            </div>
          </div>
        </v-col>
        <v-col sm="12" md="4">
          <v-card class="mx-auto" max-width="300px">
            <h2 class="v-card__title mb-4">資格查詢與預約</h2>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  v-model="input.id"
                  label="身分證字號（必填）"
                  :rules="[(v) => !!v || `身分證字號為必填項目`]"
                  outlined
                  dense
                ></v-text-field>
                <v-text-field
                  v-model="input.birth"
                  label="生日（必填）"
                  :rules="[
                    (v) => !!v || `生日為必填項目`,
                    (v) =>
                      /^\d?\d{6}$/.test(v) ||
                      `出生年月日格式錯誤，民國生日 6 碼，例如 35 年 04 月 11 日，請輸入 350411`,
                  ]"
                  outlined
                  dense
                  hint="例如 35 年 04 月 11 日，請輸入 350411"
                  persistent-hint
                ></v-text-field>
                <v-checkbox
                  v-model="checkbox[0]"
                  :rules="[(v) => v]"
                  :label="`我是設籍於${$city.name}的市民 (如為外縣市市民可預約四癌篩檢)。（必填）`"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  v-model="checkbox[1]"
                  :rules="[(v) => v]"
                  hide-details
                >
                  <template v-slot:label>
                    <div>
                      我已閱讀並同意本系統的<a
                        href="/privacy"
                        target="_blank"
                        rel="noopener"
                        title="服務條款與隱私權規範（另開新視窗）"
                        aria-label="服務條款與隱私權規範（另開新視窗）"
                        @click.stop
                        >服務條款與隱私權規範（另開新視窗）</a
                      >。（必填）
                    </div>
                  </template>
                </v-checkbox>
              </v-form>
              <v-btn x-large class="my-4" color="primary" block @click="signup"
                >查詢/預約</v-btn
              >
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import ls from "expired-localstorage";
import { 健檢項目 } from "@/libs/const.js";
const shiftCharCode = (Δ) => (c) => String.fromCharCode(c.charCodeAt(0) + Δ);
export default {
  name: "Home",
  data: () => ({
    valid: false,
    input: null,
    person: null,
    items: 健檢項目,
    checkbox: [false, false],
  }),
  created() {
    this.input = { ...this.$store.state.input };
    this.person = { ...this.$store.state.person };
  },
  methods: {
    openPrivacy() {
      // open privacy link in new tab
      open("https://www.google.com", "_blank");
    },
    focusFirstInvalidField() {
      this.$nextTick(() => {
        const invalidInput = this.$refs.form.$el.querySelector(
          ".v-input.error--text input"
        );
        if (invalidInput) {
          invalidInput.focus();
        }
      });
    },
    async signup() {
      this.input.id = this.input.id.replace(/[！-～]/g, shiftCharCode(-0xfee0));
      this.input.id = this.input.id.toUpperCase();
      this.input.id = this.input.id.trim();
      this.input.birth = this.input.birth.replace(
        /[！-～]/g,
        shiftCharCode(-0xfee0)
      );
      this.input.birth = this.input.birth.trim();
      this.$store.commit("setState", { input: this.input });
      this.valid = this.$refs.form.validate();
      if (!this.valid) {
        this.focusFirstInvalidField();
        return;
      }
      if (this.valid) {
        let data = (await this.axios.post("/signin", this.input)).data;
        if (data.errMsg) {
          this.$toast.error(data.errMsg);
        } else {
          let person = data.person;
          this.person.場次地址 = null;
          if (person.身分證字號 == this.person.身分證字號 && person.日期) {
            person = _.assign(this.person, person);
          }
          this.$store.commit("setState", {
            person,
          });
          ls.set("token", data.token);
          this.$router.push("/confirm");
          // if (!!person.日期 && dayjs() <= dayjs(person.日期).add(7, "day")) {

          // } else {
          //   this.$router.push("/personal");
          // }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  width: 250px;
  flex: 1 0 33%;
}
.item-content {
  max-width: 300px;
  margin: 0 auto;
}
.subtitle {
  width: 60%;
  text-align: center;
  justify-content: center;
  border-radius: 100px !important;
  font-size: 1.375rem !important;
  min-width: 300px;
  background-color: var(--home-subtitle-background) !important;
  color: var(--home-subtitle-text) !important;
}
.image-overlay {
  position: absolute;
  inset: 0;
  background: var(--home-image-overlay); /* 你想要的顏色 */
  mix-blend-mode: lighten; /* 或 screen, color-dodge，看效果 */
  pointer-events: none;
}
</style>
